module.exports = __webpack_public_path__ + "img/devices-mobile-feedback.fbeeb6be.png";